module.exports = __webpack_public_path__ + "img/logo-white.ab7a0fb8.png";